import React from 'react';
import { useAuth } from 'contexts/auth/auth';
import SubscriptionPage from './SubscriptionPage';
import { Role } from 'api/types/auth';
import OverviewLayout from 'components/OverviewLayout/OverviewLayout';
import Header from 'components/Layout/Header';
import Footer from 'components/Layout/Footer';
import './SubscriptionPageContainer.scss';

const SubscriptionPageContainer = () => {
  const { role } = useAuth();
  if (role !== Role.HOST) {
    return (
      <section className="PricingLayout">
        <Header />
        <SubscriptionPage />
        <Footer />
      </section>
    );
  }
  return (
    <OverviewLayout>
      <SubscriptionPage />
    </OverviewLayout>
  );
};

export default SubscriptionPageContainer;
